import graphql__0f364dde1ed7e764e597 from "./__generated__/SlideContainer_slide.graphql.js";import { forwardRef } from "react";
import { graphql, useFragment } from "react-relay";

import LinkSlide from "./LinkSlide";
import DivSlide from "./DivSlide";

// Component that decides whether the slide container should be a link or a simple
// container, depending on the presence of the slide URL and/or overlay.
//
const SlideContainer = (props, ref) => {
  const slide = useFragment(SlideContainer_slide, props.slide);
  const { url, enableOverlay } = slide;

  if (url && !enableOverlay) {
    return (
      <LinkSlide {...props} slide={slide} ref={ref}>
        {props.children}
      </LinkSlide>
    );
  } else {
    return (
      <DivSlide {...props} ref={ref}>
        {props.children}
      </DivSlide>
    );
  }
};

const SlideContainer_slide = graphql__0f364dde1ed7e764e597;

export default forwardRef(SlideContainer);
